import React, { Component } from "react";
import { getImgPath } from "../common/helper";
import { FOOTER_COMP_INFO, tCommon } from "../../translations/Common";
const excludefooterurl = [
  "himachaltouristvolvobus.com",
  "himachalvolvotravel.com",
  "adtcvolvobusservice.com",
  "himachalvolvobusservices.com",
  "volvobusticket.com",
  "volvobusticket.in",
  "himachalbustours.com",
  "himachaltouristbuses.com",
  "adtclemonbus.com",
];
const dt = new Date();
const currentyear = dt.getFullYear();
class footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        {excludefooterurl.includes(window.msurl) ? (
          ""
        ) : (
          <React.Fragment>
            <div className="footerspace" style={this.props.type === 'checkout' ? { marginTop: 0 } : {}}></div>
            <div className="footer flex-all-c">
              © {currentyear} {tCommon(FOOTER_COMP_INFO)}
              {/* <img
                src={getImgPath("/img/mantis-logo.png")}
                alt="mantis logo"
                style={{ marginLeft: "7px" }}
              /> */}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default footer;
